import { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { FacilityStatusEnum } from '../../../api';
import { PresentationStatusContext } from '../../contexts/PresentationStatusContext';
import { SessionContext } from '../../contexts/SessionContext';
import { ConnectionCombinedStatusEnum } from '../ConnectionRequestsTable/ConnectionCombinedStatusEnum';

export const PresentationStatusControl = ({
  id,
  combined_status,
}: {
  id: string;
  combined_status?: ConnectionCombinedStatusEnum;
}) => {
  const { onchange, isDisabled } = useContext(PresentationStatusContext);
  const { user } = useContext(SessionContext);
  let allowStatusChange: boolean = false;
  const allowedStatuses = [FacilityStatusEnum.PENDING_APPROVAL] as ConnectionCombinedStatusEnum[];
  if (combined_status) {
    allowStatusChange =
      allowedStatuses.includes(combined_status) &&
      (user?.group_names?.includes('grant_presentation_approval') || false);
  }

  return allowStatusChange ? (
    <div className="d-flex gap-2">
      <Button
        variant="primary"
        size="sm"
        className="btn btn-drop-shadow-sm px-3"
        disabled={isDisabled}
        onClick={() => onchange({ status: FacilityStatusEnum.APPROVED, id })}
      >
        Approve
      </Button>
      <Button
        variant="outline-danger"
        size="sm"
        className="btn btn-drop-shadow-sm px-3"
        disabled={isDisabled}
        onClick={() => onchange({ status: FacilityStatusEnum.DENIED, id })}
      >
        Decline
      </Button>
    </div>
  ) : null;
};
